/* eslint-disable react/prop-types */
import { Activity } from "lucide-react";

export function HealthBadge({ score, tier, factors = [], compact = false }) {
  const colorCls = tier === "ok"
    ? "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"
    : tier === "risk"
    ? "bg-amber-500/15 text-amber-300 border-amber-500/30"
    : "bg-red-500/15 text-red-300 border-red-500/30";
  const tip = factors.length
    ? factors.map((f) => `• ${f.text}`).join("\n")
    : "Todos os critérios em dia.";
  return (
    <div
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded border ${colorCls} ${compact ? "text-[10px]" : "text-xs"} font-semibold`}
      title={tip}
      data-testid="fleet-health-badge"
    >
      <Activity className={compact ? "w-3 h-3" : "w-3.5 h-3.5"} />
      <span className="font-mono">{score}</span>
      {!compact && <span className="text-[10px] uppercase tracking-wide opacity-75">/ 100</span>}
    </div>
  );
}
